import { Component } from '@angular/core';
import { ModalController, NavParams } from '@ionic/angular';

@Component({
  selector: 'app-sign-in',
  templateUrl: './sign-in.page.html',
  styleUrls: ['./sign-in.page.scss']
})
export class SignInPage {

  language: string;

  en_title = 'Sign In';
  en_welcome = 'Welcome back!';
  en_register = 'Enter';
  en_verify = 'Email not verified';
  en_verifyMSG = `Please verify your account in order to save your progress. If you
    verify your account now, the results from this test will not be saved.`;

  sp_title = 'Inicia Sesión';
  sp_welcome = '¡Bienvenido de nuevo!';
  sp_register = 'Entrar';
  sp_verify = 'Email no verificado';
  sp_verifyMSG = `Por favor, verifica tu cuenta para poder guardar los datos de tu progreso.
    Si verificas tu cuenta ahora, no se guardarán los resultados de este test.`;

  constructor(private _viewCtrl: ModalController, private _params: NavParams) {
    this.language = this._params.get('language');
  }

  goBack() {
    this._viewCtrl.dismiss();
  }

}
